<template>
    <div class="story-maker-sticker-menu-gif">
        <div class="search-bar">
            <i class="fa-regular fa-magnifying-glass"></i>
            <input placeholder="Recherchez" v-model="models.search">
        </div>
        <div class="list hide-scrollbar">
            <div class="list-stickers">
                <span class="loader" v-if="loading"></span>
                <template v-else-if="models.search.length || (dataInstagramDefault.gifs && dataInstagramDefault.gifs.length)">
                    <div class="gif" v-for="gif in (models.search.length ? gifs : dataInstagramDefault.gifs)" :key="gif.id">
                        <div v-if="!gifLoaded[gif.id]" class="loader"></div>
                        <img 
                            :src="gif.images.preview_gif.url" 
                            :key="'img'+gif.id"
                            @load="()=>{ $set(gifLoaded, gif.id, true)}"
                            v-show="gifLoaded[gif.id]"
                            @click="addGif(gif)"
                        >
                    </div>
                </template>
              
            </div>
        </div>
    </div>
</template>
  
<script>
    import store from './../../../../../store/index.js';
    import minxinPost from '../../../../mixins/Posts.vue'

    export default {
        mixins: [minxinPost],
        props: {
            dataInstagramDefault: Object,
        },
       
        data() {
            return {
                models: {
                    search: '',
                },
                gifs: [],
                timeout: null,
                loading: false,
                gifLoaded:{}
            }
        },
        methods: {
            async searchGif() {
                if (this.timeout) clearTimeout(this.timeout)
                this.gifs = []
                if (!this.models.search) return 
                this.loading = true

                this.timeout = setTimeout(async () => {
                    let page = this.pagesSelected.find(p => p.story_config && p.story_config.created) || this.allPages.find(p => p.story_config && p.story_config.created)
                    if (page) {
                        try {
                            this.gifs = (await this.searchGifsInstagram(page.id, this.models.search)).body.gifs.results.giphy
                        } catch (error) {}
                        this.loading = false
                    }
                },1000)
            },

            addGif(gif) {
                this.$emit('addSticker','gif', {
                    data: {
                        gif: gif,
                    }
                })
            }
        },

        computed: {
            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages'];
            },
            pagesSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected'];
            },
        },

        watch: {
            ['models.search'](newValue, oldValue) {
                this.searchGif()
            },
        }
    }
  
</script>